import { isLayerTreeGroupConfig } from './utils/layerGroup.js';
const flatGroupLayerIds = (config) => {
    return config.reduce((acc, item) => {
        if (isLayerTreeGroupConfig(item)) {
            return acc.concat(flatGroupLayerIds(item.children));
        }
        else {
            acc.push(item.layerId);
            return acc;
        }
    }, []);
};
export const deriveLegendStateFromConfig = (config) => {
    const mapLayers = config?.map?.layers ?? [];
    const layerIds = config?.layerSwitcher?.groups
        ? flatGroupLayerIds(config?.layerSwitcher.groups)
        : mapLayers.map((layer) => layer.id);
    return layerIds.reduce((acc, layerId) => {
        const mapLayer = mapLayers.find((mapLayer) => mapLayer.id === layerId);
        if (mapLayer?.legend !== false) {
            const legendParams = mapLayer?.legend;
            if (Array.isArray(legendParams)) {
                acc.push({
                    type: mapLayer?.type,
                    label: '',
                    layerId: layerId,
                });
            }
            else {
                acc.push({
                    symbolSize: legendParams?.symbolSize,
                    link: legendParams?.link,
                    imageSrc: legendParams?.imageSrc,
                    type: mapLayer?.type,
                    label: '',
                    layerId: layerId,
                });
            }
        }
        return acc;
    }, []);
};
//# sourceMappingURL=deriveLegendStateFromConfig.js.map